export var deleteAccountStyle = function (theme) { return ({
    button: {
        fontWeight: 'normal',
        minWidth: 150,
    },
    buttonOutlined: {
        border: "2px solid " + theme.palette.primary.main,
        fontWeight: 'normal',
        minWidth: 150,
    },
    error: {
        marginTop: 20,
    },
    form: {
        marginBottom: 20,
    },
    link: {
        color: '#959595',
        fontSize: 17,
        height: 'auto',
        textDecoration: 'underline',
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        borderRadius: 3,
        boxShadow: theme.shadows[5],
        left: '50%',
        outline: 'none',
        padding: theme.spacing(4),
        position: 'absolute',
        top: '20%',
        transform: 'translate(-50%, -20%)',
        width: theme.spacing(10) * 5,
    },
    root: {
        padding: '0 25px 25px 25px',
        textAlign: 'center',
    },
    successDescription: {
        fontSize: 16,
        fontWeight: 'bold',
    },
    warningDescription: {
        fontSize: 14,
        lineHeight: 1.43,
        marginBottom: 15,
    },
    warningText: {
        fontSize: 16,
        fontWeight: 'bold',
        lineHeight: 1.25,
        marginBottom: 30,
    },
}); };
//# sourceMappingURL=deleteAccount.style.js.map